import React from 'react';
import AdminDashboard from '../components/AdminDashboard';

const Admin = () => {
  return <AdminDashboard />;
};

export default Admin;
